const ConfigSectorsTypes = {
  SET_INITIALIZED: "configSectors/SET_INITIALIZED",
  SET_AREAS_LOADING: "configSectors/SET_AREAS_LOADING",
  SET_AREAS: "configSectors/SET_AREAS",
  SET_AREA_SELECTED: "configSectors/SET_AREA_SELECTED",
  SET_SECTORS_LOADING: "configSectors/SET_SECTORS_LOADING",
  SET_SECTORS: "configSectors/SET_SECTORS",
  SET_SECTORS_DATA: "configSectors/SET_SECTORS_DATA",
};

export default ConfigSectorsTypes;
